// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon_3cVWp","spin":"Icon_spin_w2n8M","spin-frames":"Icon_spin-frames_8DiOX"};